// Layouts

import registry from "../../registry"

const layouts = {
    ...registry.layouts
}

export default layouts;